import * as PIXI from 'pixi.js';
import ScaleManager from "@/stage/ScaleManager";
import {Signals} from "@/Imports";
import AxisContainer from "@/containers/AxisContainer";
import gsap from "gsap";
import Config from "@/config/Config";
import Facade from "@/Facade";

class AxesContainer extends PIXI.Container {
  constructor() {
    super();

    this.marginV = 4;
    this.marginH = 28;

    this.init();

    Signals.roundEnd.add(this.onRoundEnd, this)
    Signals.roundStart.add(this.onRoundStart, this)
  }

  init() {
    this
      .createAxes()
      .createBg()
      .createLines()
  }

  createBg() {
    const {x,y,w,h} = this.sizes
    this.bg = new PIXI.Graphics()
    this.bg.lineStyle(4, 0xfedf61)
    this.bg.drawRect(x, y, w, h)
    this.bg.endFill()

    this.addChild(this.bg)
    return this
  }

  createLines() {
    const {x,y,w,h} = this.sizes
    const gapH = 20
    const gapV = 18
    this.lines = new PIXI.Graphics()
    this.lines.lineStyle(1.4, 0xfedf61, 0.5)
    this.lines.moveTo(x + gapH, y + 10)
    this.lines.lineTo(x + gapH, h - gapV)
    this.lines.lineTo(w + gapH, h - gapV)
    this.addChild(this.lines)
    return this
  }

  createAxes() {
    const {x,y,w,h} = this.sizes

    this.verticalDots = new AxisContainer('vertical', this.sizes)
    this.verticalDots.x = x + 11
    this.verticalDots.y = y
    this.verticalDots.alpha = 0
    this.addChild(this.verticalDots)

    this.horizontalDots = new AxisContainer('horizontal', this.sizes)
    this.horizontalDots.x = x
    this.horizontalDots.y = h - 8
    this.horizontalDots.alpha = 0
    this.addChild(this.horizontalDots)

    return this
  }

  get sizes() {
    const currentWidth = ScaleManager.currentSizes.total.width
    const currentHeight = ScaleManager.currentSizes.total.height

    let x = this.marginH
    let y = this.marginV
    let w = currentWidth / 2.32 - this.marginH
    let h = currentHeight / 4 - this.marginV

    // if (Facade.orientation === 'Vm') {
    //   console.yellow('::: is Vertical!!')
    //   x = this.marginH * 4 - 16
    //   y = this.marginV - 8
    //   w = currentWidth + 6
    //   h = currentHeight
    // }
    // console.yellow(`coords: ${x}, ${y}, ${w}, ${h}`)

    return { x, y, w, h, }
  }

  update() {
  }

  onAfterStart() {
    this.verticalDots.start()
    this.horizontalDots.start()
  }

  onRoundStart() {
    Signals.afterStart.addOnce(this.onAfterStart, this)
    gsap.to(this.verticalDots, 2, {alpha: 1})
    gsap.to(this.horizontalDots, 2, {alpha: 1})
  }

  onRoundEnd() {
    this.verticalDots.stop()
    this.horizontalDots.stop()

    gsap.to(this.verticalDots, 0.5, {alpha: 0})
    gsap.to(this.horizontalDots, 0.5, {alpha: 0})
  }
}

export default AxesContainer;
